import { connect } from 'react-redux'
import BlogArticle from './BlogArticle'
import { getEntries } from 'features/Cms/Cms.actions'
import { filterAndOrderBlogs } from '../Blog.utils'

const stateToProps = ({ cms }, { routeParams: { articleSlug } }) => {
  const articles = cms.blogPost || []

  return {
    articles: filterAndOrderBlogs(articles),
    article: articles.find(item => item.fields.slug === articleSlug),
  }
}

const dispatchToProps = {
  getArticles: () => getEntries({ contentType: 'blogPost' }),
}

export default connect(stateToProps, dispatchToProps)(BlogArticle)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Blog/BlogArticle/BlogArticle.container.js